__turbopack_context__.v({
  "Caption": "Caption-module-scss-module__EyAefG__Caption",
  "CaptionContent": "Caption-module-scss-module__EyAefG__CaptionContent",
  "CaptionFunction": "Caption-module-scss-module__EyAefG__CaptionFunction",
  "CaptionImage": "Caption-module-scss-module__EyAefG__CaptionImage",
});
